import * as React from "react";
import { useRecordContext } from "react-admin";
import { Button, Tooltip } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import BlockIcon from "@mui/icons-material/Block";
import { adminPatch } from "../../config/api";
import useModerationAction from "../../hooks/useModerationAction";

export default function RejectOobjectVariantButton() {
    const record = useRecordContext();
    const { loading, run } = useModerationAction();

    if (!record || record.status === "REJECTED") return null;

    const onClick = async (event) => {
        event?.stopPropagation?.();
        await run({
            id: record.id,
            missingIdMessage: "ID variante manquant.",
            request: () =>
                adminPatch(`/oobject-variants/${record.id}/reject`, {
                    reason: null,
                }),
            successMessage: "Variante rejetée",
        });
    };

    return (
        <Tooltip title="Rejeter cette variante">
      <span>
        <Button
            onClick={onClick}
            disabled={loading}
            variant="contained"
            size="small"
            sx={{
                bgcolor: "#d32f2f",
                color: "white",
                borderRadius: "18px",
                textTransform: "none",
                px: 1.25,
                py: 0.25,
                "&:hover": { bgcolor: "#b71c1c" },
            }}
            startIcon={
                loading ? (
                    <CircularProgress size={14} sx={{ color: "white" }} />
                ) : (
                    <BlockIcon fontSize="small" />
                )
            }
        >
          Rejeter
        </Button>
      </span>
        </Tooltip>
    );
}
